import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    Button,
} from '@mui/material';
import { ToastContainer } from 'react-toastify';

const AddSkillsDialog = ({ open, onClose, onSave }) => {
    const [experience, setExperience] = useState({
        title: '',
        employmentType: '',
        company: '',
        startDate: '',
        endDate: '',
        location: '',
        description: '',
        skills: '',
        links: '',
    });

    const handleExperienceChange = (e) => {
        const { name, value } = e.target;
        setExperience((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        onSave(experience);
        // onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Add Experience</DialogTitle>
            <DialogContent>
                {/* Added Role/Job Title field */}
                <TextField
                    fullWidth
                    label="Role/Job Title"
                    name="title"
                    value={experience.title}
                    onChange={handleExperienceChange}
                    margin="normal"
                    required
                />
                <TextField
                    fullWidth
                    label="Employment Type"
                    name="employmentType"
                    value={experience.employmentType}
                    onChange={handleExperienceChange}
                    select
                    margin="normal"
                >
                    <MenuItem value="Full-time">Full-time</MenuItem>
                    <MenuItem value="Part-time">Part-time</MenuItem>
                    <MenuItem value="Internship">Internship</MenuItem>
                    <MenuItem value="Freelance">Freelance</MenuItem>
                </TextField>
                <TextField
                    fullWidth
                    label="Company or Organization"
                    name="company"
                    value={experience.company}
                    onChange={handleExperienceChange}
                    margin="normal"
                />
                <div className='w-full flex gap-2'>
                    <TextField
                        fullWidth
                        label="Start Date"
                        name="startDate"
                        type="date"
                        value={experience.startDate}
                        onChange={handleExperienceChange}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        fullWidth
                        label="End Date"
                        name="endDate"
                        type="date"
                        value={experience.endDate}
                        onChange={handleExperienceChange}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                    />
                </div>
                <TextField
                    fullWidth
                    label="Location"
                    name="location"
                    value={experience.location}
                    onChange={handleExperienceChange}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    value={experience.description}
                    onChange={handleExperienceChange}
                    margin="normal"
                    multiline
                    rows={4}
                />
                <TextField
                    fullWidth
                    label="Skills"
                    name="skills"
                    value={experience.skills}
                    onChange={handleExperienceChange}
                    margin="normal"
                    placeholder="Add skills separated by commas"
                />
                <TextField
                    fullWidth
                    label="Links"
                    name="links"
                    value={experience.links}
                    onChange={handleExperienceChange}
                    margin="normal"
                    placeholder="Add relevant links (e.g., project links)"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    Save
                </Button>
            </DialogActions>
            <ToastContainer
                position='bottom-center'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Dialog>
    );
};

export default AddSkillsDialog;